var React = require('react');

function NavIconsTemplates (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M228.1,232.2H4.5V8.6h223.6V232.2z M30.8,205.9h170.9V34.9H30.8V205.9z","key":0}),React.createElement("path",{"d":"M495.5,232.2H271.9V8.6h223.6V232.2z M298.3,205.9h170.9V34.9H298.3V205.9z","key":1}),React.createElement("path",{"d":"M361.8,361.8H138.2V138.2h223.6V361.8z M164.5,335.5h170.9V164.5H164.5V335.5z","key":2}),React.createElement("path",{"d":"M495.5,491.4H271.9V267.8h223.6V491.4z M298.3,465.1h170.9V294.1H298.3V465.1z","key":3}),React.createElement("path",{"d":"M228.1,491.4H4.5V267.8h223.6V491.4z M30.8,465.1h170.9V294.1H30.8V465.1z","key":4})]));
}

NavIconsTemplates.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 500 500","style":{"enableBackground":"new 0 0 500 500"},"xmlSpace":"preserve"};

module.exports = NavIconsTemplates;

NavIconsTemplates.default = NavIconsTemplates;
